import { ActionContext, Action } from "vuex";
import { getStoreAccessors } from "vuex-typescript";
import { State as RootState } from "../state";
import { TempState } from "./tempState";

type TempContext = ActionContext<TempState, RootState>

const getDefaultState = () => {
    return {
        idIstituto: null,
        idAnnoScolastico: 2025
    }
}

export const temp = {
    namespaced: true,
    state: getDefaultState(),
    getters: {
        getIdIstituto(state: TempState) {
            return state.idIstituto
        },
        getAnnoScolastico(state: TempState) {
            return state.idAnnoScolastico
        }
    },

    mutations: {
        editIdIstituto(state: TempState, idIstituto: number) {
            state.idIstituto = idIstituto
        }
    },

    actions: {
        setIdIstituto(context: TempContext, idIstituto: number) {
            commitSetIdIstituto(context, idIstituto)
        }
    }
}

const { commit, read, dispatch } = getStoreAccessors<TempState, RootState>("temp")
const getters = temp.getters;

export const readIdIstituto = read(getters.getIdIstituto)
export const readIdAnnoScolastico = read(getters.getAnnoScolastico)

const actions = temp.actions

export const diaspatchSetIdIstituto = dispatch(actions.setIdIstituto)

const mutations = temp.mutations

export const commitSetIdIstituto = commit(mutations.editIdIstituto)